import { css } from '@emotion/css';
import { HTMLAttributes } from 'react';

export function Anchor(props: HTMLAttributes<HTMLDivElement> & {}) {
  return <div className={anchorContentCss} {...props} />;
}

const anchorContentCss = css`
  display: flex;
  align-items: center;
  padding: 6px 18px;
  margin-bottom: 12px;
  color: var(--ant-primary-color);
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 1px 2px 0 rgba(168, 182, 191, 0.6);
  z-index: 1;
  cursor: pointer;
  transition: all 0.5s;
  > * + * {
    margin-left: 4px;
  }
  &:hover {
    box-shadow: 0px 3px 6px 0px rgba(168, 182, 191, 0.6);
    transform: translateY(-0.5px);
  }
`;
